<template>
  <div>
    <dropdown-component class="mobile-cart">
      <template v-slot:header>
        <div class="mobile-header">
          <span class="bold small">
            <span class="bold" v-if="isCostEstimate">
              {{ $t('W2P_CART_ESTIMATED_TOTAL') }}:
            </span>
            <span class="bold" v-else
              >{{ $t('W2P_CART_TOTAL_INCL_VAT') }}
            </span>
          </span>
          <span class="bold small mobile-header--blue">{{
            $n(totalPriceVAT, 'currency', 'sv-SE')
          }}</span>
        </div>
      </template>
      <template v-slot:content>
        <div class="mobile-content">
          <div class="cart--empty" v-if="!totalPrice">
            <img src="@/assets/images/common/empty-mailbox.svg" />
            <p class="small">{{ $t('W2P_EMPTY_CART_TEXT') }}</p>
            <div class="cart--loading" v-if="isLoading">
              <pn-spinner color="blue" size="large" />
            </div>
          </div>
          <div class="cart--empty" v-else-if="calculatePriceError">
            <img src="@/assets/images/common/estimate_letter_grey.svg" />
            <p class="cart__name small">{{ $t('W2P_ERROR_CART_TEXT') }}</p>
            <div class="cart--loading" v-if="isLoading">
              <pn-spinner color="blue" size="large" />
            </div>
          </div>
          <div class="cart" v-else>
            <img src="@/assets/images/common/estimate_letter.svg" />
            <p class="cart__name small">{{ mailoutName }}</p>
            <p class="cart__count tiny">
              {{ recipientsCount }} {{ $t('W2P_CART_RECIPIENTS') }}
            </p>
            <div class="cart__item">
              <p class="small">{{ $t('W2P_CART_BASE_PRICE') }}</p>
              <p class="small">{{ $n(basePrice, 'currency', 'sv-SE') }}</p>
            </div>
            <div class="cart__price-per-item">
              <p class="tiny cart__item__name">
                {{ $n(basePricePerPiece, 'currency', 'sv-SE') }}/ea
              </p>
            </div>
            <div v-for="extra in extras" :key="extra.name">
              <div class="cart__item">
                <p class="small">{{ $t(extra.name) }}</p>
                <p class="small">{{ $n(extra.price, 'currency', 'sv-SE') }}</p>
              </div>
              <div class="cart__price-per-item">
                <p class="tiny cart__item__name">
                  {{ $n(extra.pricePerPiece, 'currency', 'sv-SE') }}/ea
                </p>
              </div>
            </div>
            <div class="cart__item">
              <p class="small">{{ $t('W2P_CART_POSTAGE_PRICE') }}</p>
              <p class="small">{{ $n(totalPostage, 'currency', 'sv-SE') }}</p>
            </div>
            <div class="cart__price-per-item">
              <p class="tiny cart__item__name">
                {{ $n(postagePricePerPiece, 'currency', 'sv-SE') }}/ea
              </p>
            </div>
            <div class="cart__item">
              <p class="small">{{ $t('W2P_CART_TOTAL_EXCL_VAT') }}</p>
              <p class="small">{{ $n(totalPrice, 'currency', 'sv-SE') }}</p>
            </div>
          </div>
        </div>
      </template>
    </dropdown-component>
  </div>
</template>

<script>
import DropdownComponent from '@/components/common/dropdown/DropdownComponent'
import { mapGetters, mapState } from 'vuex'
export default {
  props: {
    service: {
      type: String,
      required: true
    }
  },
  components: {
    DropdownComponent
  },
  computed: {
    ...mapGetters(['isBusinessUser']),
    ...mapState('cart', [
      'basePrice',
      'basePricePerPiece',
      'totalExtra',
      'totalPostage',
      'postagePricePerPiece',
      'totalPrice',
      'totalPriceVAT',
      'extras',
      'isLoading',
      'calculatePriceError'
    ]),
    upload() {
      return this.$store.state[this.service].upload
    },
    address() {
      return this.$store.state[this.service].address
    },
    isCostEstimate() {
      return this.upload.isCostEstimate
    },
    mailoutName() {
      return this.upload.mailoutName
    },
    recipientsCount() {
      if (
        !this.isCostEstimate &&
        this.address &&
        this.address.numberOfRecipients
      ) {
        return this.address.numberOfRecipients
      } else {
        return this.upload.recipientsData.recipientsCount
      }
    }
  }
}
</script>

<style lang="scss">
.mobile-header {
  color: $black;
  &--blue {
    color: $blue700;
  }
}
.mobile-content {
  ul {
    padding: 0 1em;
  }

  text-align: center;
}

.cart {
  height: 100%;
  text-align: center;
  padding: 1em 2em;
  color: $black;
  width: 100%;

  &--loading {
    margin-top: 1em;
  }

  &__name {
    margin-top: 1em;
  }

  &__count {
    color: $gray700;
  }

  &--empty {
    height: 100%;
    text-align: center;
    padding: 2em 3em;
    color: $gray700;
  }

  &__price-per-item {
    display: flex;
    justify-content: space-between;
    text-align: left;
    line-height: 1em;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    margin-top: 1em;
    text-align: left;
    line-height: 1em;

    &--blue {
      color: $blue700;
    }

    &--subitem {
      margin-left: 1em;
      margin-top: 0.5em;
      display: flex;
      justify-content: space-between;
      text-align: left;
    }

    &__name {
      color: $gray700;
    }
  }
}

.mobile-cart {
  background-color: white;
  z-index: 1;
  width: 100%;
}

@media screen and (max-width: 50em) {
  .mobile-content {
    img {
      width: 40%;
    }
  }
}

@media screen and (min-width: 75em) {
  .mobile-cart {
    display: none;
  }
}
</style>
